import { Component, Vue } from "vue-property-decorator";

@Component<Header>({
  components: {}
})
export default class Header extends Vue {
  private name = "李阿丹";
  private title = "專員";

  public created() {
    // TODO: get or call api
  }

  private openMenu() {
    this.$emit("openMenu");
  }

  private logout() {
    this.$emit("logout");
  }
}
